import styled from "styled-components";

export const UserDetailStyle = styled.div`
  .member_identity {
    display: flex;
    justify-content: space-around;
  }
  .remove {
    .icon-delete {
      color: red;
    }
  }
`;
